export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Is this a physical product?',
    answer:
      'No. VOLLEYBALL COACH PRO™ is a 100% digital product, and you’ll receive access after your purchase.',
  },
  {
    question: 'Is this designed for beginner coaches?',
    answer:
      'The system is especially valuable for coaches who already understand volleyball and want practical resources that help reduce planning and preparation time.',
  },
  {
    question: 'Is this just volleyball theory?',
    answer:
      'No. The system focuses on ready-to-use practices, drills, progressions, tactical situations, planning frameworks, worksheets, templates, and coaching tools.',
  },
  {
    question: 'Can I adapt the practices to my team?',
    answer:
      'Yes. The system includes adaptable structures, progressions, variations, and different practice formats so you can select and modify resources according to your players and objectives.',
  },
  {
    question: 'Does it include complete practices?',
    answer:
      'Yes. You’ll receive ready-to-coach sessions organized around technical, tactical, and competitive objectives with timing, sequences, progressions, and coaching points.',
  },
  {
    question: 'Can it help me after matches?',
    answer:
      'Yes. The Match Problem → Practice Solution system helps you transform common competition problems into specific training priorities and practical sessions.',
  },
  {
    question: 'Can I use it throughout the season?',
    answer:
      'Yes. The system includes weekly and seasonal structures designed to help organize practices and priorities across different competitive periods.',
  },
  {
    question: 'How will I receive access?',
    answer:
      'Immediately after payment. Everything will be delivered digitally by email within minutes.',
  },
  {
    question: 'Does it work for any level, age group, or team size?',
    answer:
      'Yes. Practices, drills, and progressions include easier and more competitive versions plus adaptations for different roster sizes, so you can use the same resources with youth, school, club, or senior teams.',
  },
  {
    question: 'Is this a subscription or a one-time payment?',
    answer:
      'It’s a single one-time payment. There are no monthly fees and no renewals — you keep permanent access to every module and bonus you receive today.',
  },
]
